var map = {
	"../pages/gallery/gallery.module": [
		472,
		7
	],
	"../pages/image-preview/image-preview.module": [
		473,
		3
	],
	"../pages/list/list.module": [
		474,
		1
	],
	"../pages/login/login.module": [
		475,
		6
	],
	"../pages/report/report.module": [
		476,
		0
	],
	"../pages/supplier-details/supplier-details.module": [
		477,
		2
	],
	"../pages/supplier-list/supplier-list.module": [
		478,
		5
	],
	"../pages/version/version.module": [
		479,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 306;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 306
// module chunks = 8